export default __webpack_public_path__ + "static/media/parallax.96d83a2d.jpg";